import { defineComponent as D, computed as l, createBlock as y, openBlock as o, unref as d, withCtx as I, createElementBlock as r, createCommentVNode as i, createTextVNode as C, toDisplayString as u } from "vue";
import { RevInputText as L } from "@ds/components/InputText";
import k from "../../icons/generated/IconCalendar.vue2.js";
import { useLocale as w } from "@ds/plugin";
const _ = {
  key: 0,
  class: "text-static-default-low caption mt-8"
}, T = { key: 0 }, R = /* @__PURE__ */ D({
  name: "RevInputDate",
  __name: "InputDate",
  props: {
    clearButtonAriaLabel: { default: void 0 },
    description: { default: void 0 },
    disabled: { type: Boolean },
    enteredDateLabel: { default: void 0 },
    hasClearButton: { type: Boolean, default: !0 },
    error: { default: void 0 },
    id: {},
    label: {},
    modelValue: {}
  },
  emits: ["update:modelValue", "input", "invalid", "valid", "clear"],
  setup(s, { emit: c }) {
    const t = s, a = c, p = w(), n = l(() => !!t.modelValue), m = l(
      () => typeof t.enteredDateLabel < "u"
    ), v = l(() => n.value ? new Intl.DateTimeFormat(p.value, {
      dateStyle: "long"
    }).format(new Date(t.modelValue)) : void 0), b = (e) => {
      a("update:modelValue", e);
    }, f = (e) => {
      a("input", e);
    }, h = (e) => {
      a("invalid", e);
    }, V = () => {
      a("valid");
    }, B = () => {
      a("clear");
    };
    return (e, g) => (o(), y(d(L), {
      id: e.id,
      class: "relative cursor-text",
      "clear-button-aria-label": e.clearButtonAriaLabel,
      description: e.description,
      disabled: e.disabled,
      error: e.error,
      "has-clear-button": e.hasClearButton,
      icon: d(k),
      label: e.label,
      "model-value": e.modelValue,
      type: "date",
      onClear: B,
      onInput: f,
      onInvalid: h,
      "onUpdate:modelValue": b,
      onValid: V
    }, {
      default: I(() => [
        n.value ? (o(), r("div", _, [
          m.value ? (o(), r("span", T, u(e.enteredDateLabel), 1)) : i("", !0),
          C(" " + u(v.value), 1)
        ])) : i("", !0)
      ]),
      _: 1
    }, 8, ["id", "clear-button-aria-label", "description", "disabled", "error", "has-clear-button", "icon", "label", "model-value"]));
  }
});
export {
  R as default
};
